import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import API from '../api/api';
import "./Contact.css";

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', comment: '' });
  const [status, setStatus] = useState(null);
  const [emailError, setEmailError] = useState("");

  const navigate = useNavigate();  // ⭐ Navigation Hook

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setForm({ ...form, email: emailValue });

    if (!validateEmail(emailValue)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!validateEmail(form.email)) {
      setEmailError("Invalid email format");
      return;
    }

    try {
      await API.post('/feedbacks', form);

      setStatus({
        type: 'success',
        text: 'Feedback submitted. Thank you!'
      });

      setForm({ name: '', email: '', comment: '' });

      // ⭐ Redirect to Home after 1.5 seconds
      setTimeout(() => navigate("/"), 1500);

    } catch (err) {
      setStatus({
        type: 'error',
        text: 'Submission failed. Try again.'
      });
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-wrapper">

        {/* LEFT — CONTACT INFO */}
        <div className="info-section">
          <h2 className="info-title">Contact Information</h2>
          <p className="info-text">
            We're here to help! Feel free to reach out with questions, feedback, or support.
          </p>

          <div className="info-box">
            <i className="bi bi-envelope-fill"></i>
            <span>support@esevalink.com</span>
          </div>

          <div className="info-box">
            <i className="bi bi-phone-fill"></i>
            <span>020-4509-3482</span>
          </div>

          <div className="info-box">
            <i className="bi bi-geo-alt-fill"></i>
            <span>Pune, Maharashtra, India</span>
          </div>

          <div className="info-note">
            Your feedback helps us improve our services.
          </div>
        </div>

        {/* RIGHT — FORM */}
        <div className="form-section">
          <div className="contact-card shadow-lg">

            <h3 className="text-center heading mb-4">Send Feedback</h3>

            {status && (
              <div className={`alert ${status.type === "success" ? "alert-success" : "alert-danger"}`}>
                {status.text}
              </div>
            )}

            <form onSubmit={submit}>

              <div className="mb-3">
                <label className="form-label">Name</label>
                <input 
                  value={form.name}
                  onChange={e => setForm({ ...form, name: e.target.value })}
                  className="form-control input-box"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  value={form.email}
                  onChange={handleEmailChange}
                  className={`form-control input-box ${emailError ? 'is-invalid' : ''}`}
                  required
                />
                {emailError && <div className="invalid-feedback">{emailError}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label">Comment</label>
                <textarea
                  value={form.comment}
                  onChange={e => setForm({ ...form, comment: e.target.value })}
                  className="form-control input-box"
                  rows="4"
                  required
                />
              </div>

              <button 
                className="btn send-btn w-100"
                disabled={emailError !== ""}
              >
                Send Feedback
              </button>

            </form>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;
